import { LANDING_PAGES } from '@/landing/video-translator/config';
import {
  aiReelGeneratorURL,
  aiRemovalURL,
  aiTiktokVideoURL,
  aiTwinGeneratorURL,
  aiUgcVideoURL,
  aiVideoEditURL,
  avatarVideoProURL,
  dropshippingVideoAdsURL,
  facebookVideoAdURL,
  faceSwapperURL,
  gptImage2URL,
  homeURL,
  imageEnhanceURL,
  imageGenerateURL,
  imageTranslationURL,
  PolicyURL,
  pricingURL,
  productAvatarURL,
  seedance20URL,
  TermsURL,
  videoGenerateURL,
  videoTranslateURL,
  viralTemplateURL,
  voiceCloneURL,
} from '@/utils/routeConstants';

export const ASSET_BASE = '/figma-assets/home-redesign';

export interface HeroVideoItem {
  id: string;
  label: string;
  poster: string;
  videoUrl?: string;
}

export interface TemplateVideoItem {
  id: string;
  category: string;
  /** 未设置时不展示趋势角标（接口列表无该字段） */
  trend?: string;
  title: string;
  poster: string;
  videoUrl?: string;
}

/** 与接口 `tmpl/page` 首页条数对齐（5 列 × 3 行） */
export const HOME_TEMPLATE_GRID_PAGE_SIZE = 15;

export const HOME_CTA_URL = homeURL;

export const heroVideos: HeroVideoItem[] = [
  {
    id: 'creator-live',
    label: 'AI generated',
    poster: `${ASSET_BASE}/8465718bf069dbc093f0fc25fad9ec642593092e.png`,
  },
  {
    id: 'beauty-demo',
    label: 'AI generated',
    poster: `${ASSET_BASE}/f6615d5c1143883b26c5013031b15ea68d5182cc.png`,
  },
  {
    id: 'product-review',
    label: 'AI generated',
    poster: `${ASSET_BASE}/5488ea0f9a28312585d5699d93923f3f5a78b263.png`,
  },
  {
    id: 'homeware',
    label: 'AI generated',
    poster: `${ASSET_BASE}/c5fd5afd1eae105d1cdec196e2a681574dd4b2b3.png`,
  },
  {
    id: 'kitchen-ugc',
    label: 'AI generated',
    poster: `${ASSET_BASE}/b1485d0a4f790cbe5d66780ca079414f5fa320f5.png`,
  },
  {
    id: 'beauty-demo-2',
    label: 'AI generated',
    poster: `${ASSET_BASE}/f6615d5c1143883b26c5013031b15ea68d5182cc.png`,
  },
  {
    id: 'product-review-2',
    label: 'AI generated',
    poster: `${ASSET_BASE}/5488ea0f9a28312585d5699d93923f3f5a78b263.png`,
  },
];

/** AI Avatar 区块：左栏 3 路（rc 预览），右栏 3 路（爆款模板素材）；默认静音循环，右下角可开声 */
export const AVATAR_SHOWCASE_LEFT_VIDEOS: HeroVideoItem[] = [
  {
    id: 'avatar-showcase-left-1',
    label: 'Avatar',
    poster: '',
    videoUrl:
      'https://rc.falcocut.com/vcm/20004/20240914/154200/960989792722944/9609897927229448.mp4',
  },
  {
    id: 'avatar-showcase-left-2',
    label: 'Avatar',
    poster: '',
    videoUrl:
      'https://rc.falcocut.com/vcm/20004/20240914/154144/960923665326080/9609236653260807.mp4',
  },
  {
    id: 'avatar-showcase-left-3',
    label: 'Avatar',
    poster: '',
    videoUrl:
      'https://rc.falcocut.com/vcm/20004/20240914/154131/960870695460864/9608706954608644.mp4',
  },
];

export const AVATAR_SHOWCASE_RIGHT_VIDEOS: HeroVideoItem[] = [
  {
    id: 'avatar-showcase-right-1',
    label: 'Avatar',
    poster: '',
    videoUrl:
      'https://falcocut-assets-sgp-1375136936.cos.ap-singapore.myqcloud.com/popular-templates/1774509699525-juuklr.mp4',
  },
  {
    id: 'avatar-showcase-right-2',
    label: 'Avatar',
    poster: '',
    videoUrl:
      'https://falcocut-assets-sgp-1375136936.cos.ap-singapore.myqcloud.com/popular-templates/1774509499415-rcldjt.mp4',
  },
  {
    id: 'avatar-showcase-right-3',
    label: 'Avatar',
    poster: '',
    videoUrl:
      'https://falcocut-assets-sgp-1375136936.cos.ap-singapore.myqcloud.com/popular-templates/1774508698013-8aa952.mp4',
  },
];

export const customerLogos = [
  { id: 'honor', src: '/images/brand-logo/honor.png', alt: 'Honor' },
  { id: 'huaxizi', src: '/images/brand-logo/huaxizi.png', alt: 'Florasis' },
  { id: 'xiaomi', src: '/images/brand-logo/xiaomi.png', alt: 'Xiaomi' },
  { id: 'dji', src: '/images/brand-logo/dji.png', alt: 'DJI' },
  { id: 'anker', src: '/images/brand-logo/anker.png', alt: 'Anker' },
  { id: 'tiktok', src: '/images/brand-logo/tiktok.png', alt: 'TikTok' },
  { id: 'insta360', src: '/images/brand-logo/360.png', alt: 'Insta360' },
  { id: 'haier', src: '/images/brand-logo/haier.png', alt: 'Haier' },
  { id: 'chuanyin', src: '/images/brand-logo/chuanyin.png', alt: 'Transsion' },
  { id: 'vivavideo', src: '/images/brand-logo/vivavideo.png', alt: 'VivaVideo' },
];

// export const templateVideos: TemplateVideoItem[] = [
//   {
//     id: 'trending-product',
//     category: 'Trending',
//     trend: '1.2M',
//     title: 'Turn product photos into high-converting ads',
//     poster: `${ASSET_BASE}/5d0656e4d553430380251ab69e6565b9fd49c85e.png`,
//   },
//   {
//     id: 'hook',
//     category: 'Hook',
//     trend: '650K',
//     title: 'Open with a stronger scroll-stopping hook',
//     poster: `${ASSET_BASE}/21cfbcc07af0592b36a2d3bdccb13ba299086927.png`,
//   },
//   {
//     id: 'ai-generated',
//     category: 'AI Generated',
//     trend: '920K',
//     title: 'Create robot and tech story ads in minutes',
//     poster: `${ASSET_BASE}/075ccac42949216e33c0b913804372fb0e8eb78c.png`,
//   },
//   {
//     id: 'beauty',
//     category: 'Beauty',
//     trend: '980K',
//     title: 'Showcase beauty products with polished scenes',
//     poster: `${ASSET_BASE}/3098d944c676d0a4f68dcb2e4115e1fa96face5e.png`,
//   },
//   {
//     id: 'sports',
//     category: 'Sports',
//     trend: '540K',
//     title: 'Create fitness creatives for social campaigns',
//     poster: `${ASSET_BASE}/a0ff739166bb1057a1fa11f815d83cb57a2ff7a6.png`,
//   },
//   {
//     id: 'ecommerce',
//     category: 'E-commerce',
//     trend: '880K',
//     title: 'Convert static product photos into video ads',
//     poster: `${ASSET_BASE}/3b91e00ef2bd52e45a79d24f9506d68e43bb2257.png`,
//   },
//   {
//     id: 'fashion',
//     category: 'Fashion',
//     trend: '850K',
//     title: 'Build fashion looks for creator-style videos',
//     poster: `${ASSET_BASE}/8fc8dd7c6f14d892098234f135363bdd8c059092.png`,
//   },
//   {
//     id: 'food',
//     category: 'Food',
//     trend: '430K',
//     title: 'Make food and beverage content feel premium',
//     poster: `${ASSET_BASE}/6746aaa33d0d7d73b963ee10fac41c91caba868d.png`,
//   },
//   {
//     id: 'education',
//     category: 'Education',
//     trend: '760K',
//     title: 'Explain products and ideas with simple scenes',
//     poster: `${ASSET_BASE}/76b6f6e777c94176415cfc129f24fab31a7bf14f.png`,
//   },
//   {
//     id: 'lifestyle',
//     category: 'Lifestyle',
//     trend: '720K',
//     title: 'Design lifestyle clips that feel native to feeds',
//     poster: `${ASSET_BASE}/70419f5282c942189971017cfe55704b1d23f6f9.png`,
//   },
//   {
//     id: 'travel',
//     category: 'Travel',
//     trend: '380K',
//     title: 'Turn travel concepts into atmospheric short videos',
//     poster: `${ASSET_BASE}/196965ec56fe09938ae1cfe00ee9461df250dd36.png`,
//   },
//   {
//     id: 'food-2',
//     category: 'Food',
//     trend: '430K',
//     title: 'Make food and beverage content feel premium',
//     poster: `${ASSET_BASE}/6746aaa33d0d7d73b963ee10fac41c91caba868d.png`,
//   },
//   {
//     id: 'education-2',
//     category: 'Education',
//     trend: '760K',
//     title: 'Explain products and ideas with simple scenes',
//     poster: `${ASSET_BASE}/76b6f6e777c94176415cfc129f24fab31a7bf14f.png`,
//   },
//   {
//     id: 'lifestyle-2',
//     category: 'Lifestyle',
//     trend: '720K',
//     title: 'Design lifestyle clips that feel native to feeds',
//     poster: `${ASSET_BASE}/70419f5282c942189971017cfe55704b1d23f6f9.png`,
//   },
//   {
//     id: 'marketing',
//     category: 'Marketing',
//     trend: '690K',
//     title: 'Generate campaign clips for launches and promos',
//     poster: `${ASSET_BASE}/f4dc3382f4023e1fd64986d45d20d5d63bf85b3d.png`,
//   },
// ];

export const toolTags = [
  { label: 'Text to Video', href: videoGenerateURL },
  { label: 'Image to Video', href: videoGenerateURL },
  { label: 'AI Avatar', href: avatarVideoProURL },
  { label: 'AI Voice', href: voiceCloneURL },
  { label: 'Face Swap', href: faceSwapperURL },
  { label: 'Video Translation', href: videoTranslateURL },
  { label: 'AI Removal', href: aiRemovalURL },
  { label: 'Image Enhance', href: imageEnhanceURL },
  { label: 'Templates', href: viralTemplateURL },
  { label: 'Product Ads', href: productAvatarURL },
];

export const stats = [
  { value: '10M+', label: 'Videos created' },
  { value: '2M+', label: 'Active users' },
  { value: '150+', label: 'AI Templates' },
  { value: '4.9 ★', label: 'Avg. rating' },
];

export const featureBlocks = [
  {
    eyebrow: 'From image to',
    title: 'Ad Video',
    description:
      'Create ready-to-publish product videos from a single image with smooth camera movement, realistic scenes, and engaging ad-style visuals.',
    cta: 'Create video',
    href: homeURL,
    image: `${ASSET_BASE}/from-image-to.png`,
    items: [
      'Optimized for paid ads & social',
      'Studio-quality motion effects',
      'Faster content production',
    ],
  },
  {
    eyebrow: 'AI Product',
    title: 'Photography',
    description:
      'Turn ideas into studio-quality product visuals for ads, social posts, product launches, and branded campaigns in seconds.',
    cta: 'Create Visuals',
    href: avatarVideoProURL,
    image: `${ASSET_BASE}/ai-product.png`,
    items: ['Studio-quality visuals', 'Built for ads', 'Fast creative production'],
  },
];

export const testimonials = [
  {
    quote:
      "We've cut our video production costs by 90% and increased output by 10x. The AI avatars are so realistic, our customers can't tell the difference.",
    name: 'Sarah Chen',
    role: 'Head of Marketing · TechFlow',
    icon: `${ASSET_BASE}/TestimonialsSection-1.png`,
  },
  {
    quote:
      'The voice cloning feature is a game-changer. I can now create content in multiple languages without hiring voice actors. Absolutely incredible.',
    name: 'Marcus Johnson',
    role: 'Content Creator · @marcusjohnson',
    icon: `${ASSET_BASE}/TestimonialsSection-2.png`,
  },
  {
    quote:
      'From concept to final video in under 10 minutes. This tool has completely transformed how we approach product launches and marketing campaigns.',
    name: 'Emily Rodriguez',
    role: 'E-commerce Director',
    icon: `${ASSET_BASE}/TestimonialsSection-3.png`,
  },
];

/** 与 `components/Footer/index.tsx` 中 Solutions 一致：slug → 展示名 */
function formatVideoTranslatorSlugToTitle(slug: string): string {
  return slug
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

const footerSolutionLinks = LANDING_PAGES.map((page) => ({
  text: formatVideoTranslatorSlugToTitle(page.slug),
  href: `/tools/video-translator/${page.slug}`,
}));

/** 与主站 Footer 链接结构对齐（英文） */
export const footerSections = [
  {
    title: 'Product',
    links: [
      { text: 'AI Video Generator', href: videoGenerateURL },
      { text: 'AI Image Generator', href: imageGenerateURL },
      { text: 'AI Video Editor', href: aiVideoEditURL },
      { text: 'Video Translation', href: videoTranslateURL },
      { text: 'Image Translation', href: imageTranslationURL },
      { text: 'AI Avatar Generator', href: avatarVideoProURL },
      { text: 'Product Avatar', href: productAvatarURL },
      { text: 'Face Swap', href: faceSwapperURL },
      { text: 'AI Removal', href: aiRemovalURL },
      { text: 'Voice Clone', href: voiceCloneURL },
      { text: 'Image Enhance', href: imageEnhanceURL },
    ],
  },
  {
    title: 'Solutions',
    links: footerSolutionLinks,
  },
  {
    title: 'Resources',
    links: [
      { text: 'AI TikTok Video Generator', href: aiTiktokVideoURL },
      { text: 'AI UGC Video Generator', href: aiUgcVideoURL },
      { text: 'AI Twin Generator', href: aiTwinGeneratorURL },
      { text: 'Seedance 2.0', href: seedance20URL },
      { text: 'Facebook Video Ad Creator', href: facebookVideoAdURL },
      { text: 'Dropshipping Video Ads Maker', href: dropshippingVideoAdsURL },
      { text: 'AI Reel Generator', href: aiReelGeneratorURL },
      { text: 'GPT Image 2', href: gptImage2URL },
    ],
  },
  {
    title: 'Company',
    links: [
      { text: 'Pricing', href: pricingURL },
      { text: 'Terms of Service', href: TermsURL },
      { text: 'Privacy Policy', href: PolicyURL },
    ],
  },
];
